var file_upload_viewer_default = {
  "fontElementMap": "loRfM",
  "file_upload_container": "uDstt",
  "file_upload_link": "_2g8Xi",
  "file_upload_error_container": "bRxq-",
  "file_upload_file_info": "-wG6l",
  "file_upload_type_icon": "_8Lzuz",
  "file_upload_status_icon_container": "h7fpB",
  "file_upload_status_icon": "ExRkG",
  "file_upload_description": "xFHWR",
  "file_upload_name_container": "vCFbo",
  "file_upload_name": "r66bh",
  "file_upload_extension": "bA1Ps",
  "file_loader_icon": "tRRvb",
  "file_upload_icon_frame": "kuBXG",
  "file_upload_icon_background": "L5aWD"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
